import React from "react";
import { gradient_primary } from "../../assets/data/colors";

// the features
const features = [
    {
        title: "Showcase your work",
        desc: "Share clinic pictures, cases, and before/after galleries that build patient trust."
    },
    {
        title: "Online booking",
        desc: "Let patients book appointments directly from your dental site, 24/7."
    },
    {
        title: "Blogs & social links",
        desc: "Share educational blog posts and connect all your social media accounts."
    },
    {
        title: "Custom to you",
        desc: "Request any feature you want — the site is built and hosted specifically for your clinic."
    }
]

const AboutDentalSite = () => {
    return (
        <div className="grid md:grid-cols-2 gap-6">
            <div style={{background: gradient_primary}} className="rounded-3xl p-8 relative overflow-hidden flex flex-col justify-between min-h-[320px]">
                <div className="absolute inset-0 stripe-bg opacity-20" />
                <div>
                    <p className="text-xs font-semibold tracking-[3px] uppercase text-[#85B7EB] mb-4">Your Online Presence</p>
                    <h2 className="text-3xl font-bold text-white mb-4">A site built just for your patients</h2>
                    <p className="text-white/70 font-light leading-relaxed text-sm text-justify">A fully dedicated website designed to showcase your clinic to the world — share it with your patients, highlight your services and results, and attract new clients through modern, professional online presence and targeted advertising.</p>
                </div>

                <div className="mt-8 inline-block bg-white/10 border border-white/20 rounded-xl px-4 py-2 text-white text-sm font-medium">
                    Managed from your dashboard ↗
                </div>
            </div>

            <div className="flex flex-col gap-3">
                {features.map((item, i) => (
                    <div key={i} className="cursor-pointer bg-white dark:bg-[#0d1117] border-gray-100 dark:border-gray-800 rounded-2xl p-5 flex gap-4 items-start">
                        <div className="w-8 h-8 rounded-lg grad-bg flex items-center justify-center text-black dark:text-white text-xs font-bold flex-shrink-0">
                            {i + 1}
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-900 dark:text-white text-md mb-1">{item.title}</h4>
                            <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};
export default AboutDentalSite;